<div class="date-time-picker">
  <div class="date_from_to" (change)="checkAllValidation()">
    <div class="form-group calendar-body" [class.another_style]="anotherDate">
      <div class="d-flex flex-row justify-content-between">
        <div class="form-control d-flex align-items-center user-input"
             [class.hasError]="hasErr || isEmpty"
             style="width: 70%;">
          <span class="date-caption">{{config.caption}}</span>
          <input type="tel" min="1" max="31" maxlength="2"
                 [(ngModel)]="dataTimeShamsi[0]"
                 placeholder="00" (keyup)="nextSiblin($event,2)" style="padding-left: 0 !important;padding-right: 0 !important;text-align: center;">
          <i class="input_divider">/</i>
          <input type="tel" min="1" max="12" maxlength="2"
                 [(ngModel)]="dataTimeShamsi[1]"
                 placeholder="00" (keyup)="nextSiblin($event,2)">
          <i class="input_divider">/</i>
          <input type="tel" min="1300" max="1400" maxlength="4"
                 [(ngModel)]="dataTimeShamsi[2]"
                 placeholder="0000" (keyup)="nextSiblin($event,4, true)">
        </div>
        <!-- =============== Calendar Picker Image =============== -->
        <div class="calendar-picker" (click)="dialogIsOpen = true"
        style="display: flex; align-items: center; height: 50px;"
             [ngStyle]="{'width': config.calendarPickerStyle.width,
             'background': config.calendarPickerStyle.background,
             'border-radius': config.calendarPickerStyle.borderRadius,'padding': config.calendarPickerStyle.padding}">
          <img style="height: 25px;" src="assets/img/calendar.svg" class="calender from-time" *ngIf="!anotherDate">
          <img src="assets/img/calendar2.svg" class="calender from-time" *ngIf="anotherDate" style="width: 25px">
          <span *ngIf="!anotherDate">{{config.calendarCaption}}</span>
        </div>
      </div>
      <!-- azade  -->
        <span *ngIf="hasErr" class="spanError">تاریخ انتخاب شده صحیح نمی باشد.</span>
        <span *ngIf= "isEmpty" class="spanError">پر کردن این بخش الزامی است.</span>
        <span *ngIf= "showStar" class="star" style="top: 12px;">*</span>
       <!-- azade  -->
    </div>

  </div>
</div>

<!-- Date Picker Modal-->
<div class="date-picker-dialog" [class.open]="dialogIsOpen">
  <div class="dialog-container">
    <div class="dialog-body">
      <app-data-picker #iosLikeComponent [changed]="changed" [data]="data" (change)="dateChanged($event)"></app-data-picker>
    </div>
    <div class="dialog-footer">
      <button class="btn purpleBtn btn-auto change-dte" (click)="setDate()">تغییر</button>
      <button class="btn btn-auto cancel-dte" (click)="closeDialog()">انصراف</button>
    </div>
  </div>
</div>
<div class="fade show" [ngClass]="{'modal-backdrop':dialogIsOpen}"></div>
